import { Instagram, Facebook, Mail, MapPin, Phone } from "lucide-react";
import Logo from "./Logo";
import { SITE, waLink, scrollToHash } from "../config/site";
import { PRODUCTS } from "../data/products";
import { WhatsAppIcon } from "./DealerSection";

const QUICK = [
  { label: "Home", hash: "#top" },
  { label: "Franchise", path: "/franchise" },
  { label: "Our Story", hash: "#story" },
  { label: "Products", hash: "#products" },
  { label: "Why TMV", hash: "#why" },
  { label: "Dealer Enquiry", hash: "#dealer" },
];

const Footer = () => (
  <footer id="contact" data-testid="site-footer" className="relative overflow-hidden bg-espresso pt-24">
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <div className="grid gap-14 pb-20 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-cream/60">{SITE.statement}</p>
          <div className="mt-7 flex gap-3">
            <a data-testid="footer-instagram-link" href={SITE.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="flex h-10 w-10 items-center justify-center rounded-full border border-cream/20 text-cream/70 transition-all duration-300 hover:border-gold hover:text-gold">
              <Instagram size={16} />
            </a>
            <a data-testid="footer-facebook-link" href={SITE.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="flex h-10 w-10 items-center justify-center rounded-full border border-cream/20 text-cream/70 transition-all duration-300 hover:border-gold hover:text-gold">
              <Facebook size={16} />
            </a>
            <a data-testid="footer-whatsapp-link" href={waLink("Hello TMV Coffee!")} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="flex h-10 w-10 items-center justify-center rounded-full border border-cream/20 text-cream/70 transition-all duration-300 hover:border-gold hover:text-gold">
              <WhatsAppIcon className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div className="md:col-span-2">
          <p className="mb-6 text-[11px] uppercase tracking-widest2 text-gold">Quick Links</p>
          <ul className="space-y-3.5">
            {QUICK.map((l) => (
              <li key={l.label}>
                {l.path ? (
                  <a
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    href={l.path}
                    className="text-sm text-cream/60 transition-colors duration-300 hover:text-cream"
                  >
                    {l.label}
                  </a>
                ) : (
                  <button
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    onClick={() => scrollToHash(l.hash)}
                    className="text-sm text-cream/60 transition-colors duration-300 hover:text-cream"
                  >
                    {l.label}
                  </button>
                )}
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="mb-6 text-[11px] uppercase tracking-widest2 text-gold">Products</p>
          <ul className="space-y-3.5">
            {PRODUCTS.map((p) => (
              <li key={p.slug}>
                <a data-testid={`footer-product-link-${p.slug}`} href={`/products/${p.slug}`} className="text-sm text-cream/60 transition-colors duration-300 hover:text-cream">
                  {p.name.replace("TMV ", "")}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="mb-6 text-[11px] uppercase tracking-widest2 text-gold">Contact</p>
          <ul className="space-y-4 text-sm text-cream/60">
            <li className="flex items-start gap-3">
              <Phone size={15} className="mt-0.5 shrink-0 text-gold/70" />
              <a data-testid="footer-phone-link" href={`tel:${SITE.phone}`} className="transition-colors hover:text-cream">{SITE.phone}</a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={15} className="mt-0.5 shrink-0 text-gold/70" />
              <a data-testid="footer-email-link" href={`mailto:${SITE.email}`} className="transition-colors hover:text-cream">{SITE.email}</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={15} className="mt-0.5 shrink-0 text-gold/70" />
              <span>{SITE.address}</span>
            </li>
          </ul>
          <a
            data-testid="footer-chat-whatsapp-button"
            href={waLink("Hello TMV Coffee, I have an enquiry.")}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-7 inline-flex items-center gap-2.5 rounded-full bg-gold px-6 py-3 text-[11px] font-semibold uppercase tracking-[0.15em] text-espresso transition-all duration-300 hover:bg-cream"
          >
            <WhatsAppIcon className="h-4 w-4" />
            Chat on WhatsApp
          </a>
        </div>
      </div>

      <div className="select-none overflow-hidden border-t border-cream/10 pt-6" aria-hidden="true">
        <p className="whitespace-nowrap text-center font-display text-[13vw] leading-none text-cream/[0.06]">
          TMV COFFEE
        </p>
      </div>

      <p className="border-t border-cream/10 py-7 text-center text-xs text-cream/40">
        © TMV Coffee – The Modern Village Coffee
      </p>
    </div>
  </footer>
);

export default Footer;
